import { v4 as uuid } from 'uuid';
import { SHARED_DIALOG_ACTION_TYPES } from '../../constants/sharedDialog.constants';

export const showAttachmentDialog = ({ requestId = uuid(), ...options } = {}) => ({
  type: SHARED_DIALOG_ACTION_TYPES.SHOW_ATTACHMENT_DIALOG,
  payload: { ...options, requestId },
});

export const hideAttachmentDialog = (requestId) => ({
  type: SHARED_DIALOG_ACTION_TYPES.HIDE_ATTACHMENT_DIALOG,
  payload: { requestId },
});

export const attachmentDialogSaved = (attachment, requestId) => ({
  type: SHARED_DIALOG_ACTION_TYPES.ATTACHMENT_DIALOG_SAVED,
  payload: { attachment, requestId },
});
